import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import { useHistory } from "react-router";
import React, { forwardRef, useMemo } from "react";
import PageRecord from "models/view-models/page-record";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import DeprecatedShow from "atoms/wrappers/show";
import { useGetPageRoute } from "utilities/hooks/domain/notebooks/pages/use-get-page-route";

export interface OpenPageMenuItemProps extends ButtonProps {
    page: PageRecord;
}
const CSS_CLASS_NAME = "c-page-context-menu";

const OpenPageMenuItem = forwardRef<HTMLButtonElement, OpenPageMenuItemProps>(
    (props, _) => {
        const { page } = props;
        const { t } = useLocalization();
        const history = useHistory();
        const { can } = usePageActionPermission(page);
        const canOpen = useMemo(() => can(PageAction.Open), [can]);
        const { getPageRoute } = useGetPageRoute();

        const handleOpenPage = (e: React.MouseEvent<HTMLButtonElement>) => {
            e.currentTarget.blur();

            const route = getPageRoute(page);

            if (route != null) {
                history.push(route);
            }
        };

        return (
            <DeprecatedShow when={canOpen}>
                <Button
                    dataTestId="notebook-page--page-context-menu--open-page-button"
                    accessibleText={t("openItem", {
                        item: t("page"),
                    })}
                    cssClassName={`${CSS_CLASS_NAME}__button`}
                    onClick={handleOpenPage}>
                    <Icon type={Icons.Document}></Icon>
                    {t("openPage")}
                </Button>
            </DeprecatedShow>
        );
    }
);

export default OpenPageMenuItem;
